import React, { useState } from "react";
import "./AddCollectionModal.css";
import { useLanguage } from "../../../../LanguageProvider";
import { IoCloseOutline } from "react-icons/io5";
import { TbStack2 } from "react-icons/tb";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { useToaster } from "../../../../ToasterProvider";

export default function AddCollectionModal({ isOpen, onClose, onCreate }) {
  const { toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const [collectionTitle, setCollectionTitle] = useState("");

  if (!isOpen) return null;

  const handleCreate = () => {
    if (collectionTitle.trim() === "") {
      toastWarning(getTranslation("collectionNameCantBeEmpty"));
      return;
    }
    onCreate(collectionTitle);
    onClose();
    setCollectionTitle("");
  };

  return (
    <div className="add-collection-modal-overlay">
      <div className="add-collection-modal-container">
        <IoCloseOutline
          className="add-collection-modal-button close"
          onClick={onClose}
        />

        <p className="add-collection-modal-title">
          {getTranslation("createNewCollection")}
        </p>

        <AddModalInputField
          icon={<TbStack2 size={22} style={{ width: "25px" }} />}
          placeholder={getTranslation("collectionTitle") + "*"}
          value={collectionTitle}
          onChange={(e) => setCollectionTitle(e.target.value)}
          type={"text"}
        />

        <div className="add-collection-modal-actions">
          <button
            className="add-collection-modal-button create"
            onClick={handleCreate}
          >
            {getTranslation("create")}
          </button>
        </div>
      </div>
    </div>
  );
}
